<!--Department landing page with required nav bar and starting parallax image.
    Optional:
    - card_and_card_banner
    - quick_links
    - information_carousel
    - parallax_image
    - image_carousel
    - paragraph_and_image_banner
    - title_and_text_banner
    - multiple_image_carousel
-->

<template>
  <div class="pad">

    <!--Parallax image with department logo and title-->

    <mdb-parallax v-if="!loading" :src="`${page_image_url}`" height="half" factor="1.4" class="d-none d-lg-block">
      <mdb-mask overlay="black-light">
        <mdb-row class="fixed-bottom mt-1">
          <mdb-col>
            
            <!--Image for large screens-->

            <img
              alt="Washoetribe logo"
              class="img-fluid mx-auto mb-5"
              :src="`${page_logo_url}`"
              style="width: 250px;"
            />

            <h3 class="font-weight-bold mb-lg-5 text-white">{{page_title}}</h3>
          </mdb-col>
        </mdb-row>
      </mdb-mask>
    </mdb-parallax>

    <!--Static PageHeader image with logo for mobile devices (includes ipad b/c of safari issue)-->

    <div :style="{ 'background-image': 'url(' + page_image_url + ')' }" style="height: 300px; background-position: center;" class="d-md-block d-lg-none">
      <mdb-mask>
        <mdb-container>
          <mdb-row>
            <mdb-col>
              <img 
                alt="Washoetribe Logo"
                class="img-fluid mx-auto mt-5 pt-5"
                :src="`${page_logo_url}`"
                style="width: 150px;"
              />
              <h3 class="font-weight-bold mb-lg-5 text-white">{{page_title}}</h3>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </div>

    <mdb-container fluid v-if="!loading">
    </mdb-container>

    <!--Nav Bar-->

    <div class="d-md-block d-none navbar font-weight-bold">

      <!--Computer-only menu-->

      <ul id="menu" class="py-lg-3 pt-md-4">
        <li v-for="link in navigation_info" :key="link.id">
          <router-link class="mr-3 nav-link" :to="'/'+link.value.page.link_page + '/' +link.value.page.slug">
            {{link.value.title}}
          </router-link>
        </li>
      </ul>
    </div>
    <div class="d-block d-md-none font-weight-bold navbar">

      <!--Mobile-friendly menu display-->

      <ul id="menu_mobile">
        <li v-for="link in navigation_info" :key="link.id" class="my-2">
          <router-link class="nav-link" :to="'/'+link.value.page.link_page + '/' +link.value.page.slug">
            {{link.value.title}}
          </router-link>
        </li>
      </ul>
    </div>

    <!--All other components are optional (user-decided) and follow:-->

    <template v-for="block in content">
      <component :is="block.type" :block="block" :key="block.id"></component>
    </template>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbParallax,
  mdbNavbar,
  mdbNavbarNav,
  mdbMask
} from "mdbvue";
import axios from "axios";
import api from "@/api"
import parallax_image from "@/components/streamfields/parallax_image.vue";
import title_and_text_banner from "@/components/streamfields/landingPageComponents/title_and_text_banner.vue";
import paragraph_and_image_banner from "@/components/streamfields/landingPageComponents/paragraph_and_image_banner.vue";
import card_and_card_banner from "@/components/streamfields/landingPageComponents/card_and_card_banner.vue";
import information_carousel from "@/components/streamfields/landingPageComponents/info_carousel/information_carousel.vue";
import image_carousel from "@/components/streamfields/landingPageComponents/image_carousel.vue";
import quick_links from "@/components/streamfields/landingPageComponents/quick_links.vue";
import multiple_image_carousel from "@/components/streamfields/landingPageComponents/multiple_image_carousel.vue";
import recent_items from "@/components/streamfields/recent_items/recent_items.vue";
import full_richtext from "@/components/streamfields/full_richtext.vue";
import shared from "@/shared";
export default {
  name: "DepartmentLandingPage",
  props: {
    slug: String
  },
  data() {
    return {
      page_title: String,
      page_logo_url: String,
      page_image_url: String,
      navigation_info: String,
      content: Array,
      loading: true
    };
  },
  mounted() {
    this.getData();
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbParallax,
    mdbNavbar,
    mdbNavbarNav,
    mdbMask,
    parallax_image,
    title_and_text_banner,
    paragraph_and_image_banner,
    card_and_card_banner,
    information_carousel,
    image_carousel,
    quick_links,
    multiple_image_carousel,
    recent_items,
    full_richtext
  },
  methods: {
    getData: function() {
      axios
        api.get("pages/" + this.slug)
        .then(response => {
          var page = response.data;
          this.page_title = page.title;
          this.page_logo_url = page.logo.url;
          this.page_image_url = page.department_image.url;
          this.navigation_info = page.department_navigation[0].value;
          this.content = page.content;
          shared.setDepartmentSkin(page.department_color_scheme[0].value.color_scheme);
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    slug: function() {
      // watch it
      this.getData();
    }
  }
};
</script>

<style scoped>
ul#menu li {
  display: inline;
}

#menu_mobile {
  list-style-type: none;
  padding-inline-start: 0px;
}
</style>
